import { CaseUtil } from '@vectord/utils';

export enum AllowedEmailTo {
  OWNER = 'owner',
  LEAD = 'lead',
}

export const allowedEmailToOptions = Object.values(AllowedEmailTo).map((value) => ({
  label: CaseUtil.titleCase(value),
  value,
}));

export enum TaskScheduleUnitEnum {
  MINUTES = 'minutes',
  HOURS = 'hours',
  DAYS = 'days',
  WEEKS = 'weeks',
  MONTHS = 'months',
  YEARS = 'years',
}

export const taskScheduleUnitOptions = Object.values(TaskScheduleUnitEnum).map((value) => ({
  label: CaseUtil.titleCase(value),
  value,
}));

export enum WebengageMappingSourceType {
  LEAD_ATTRIBUTE = 'lead_attribute',
  LEAD_ACTIVITY_ATTRIBUTE = 'lead_activity_attribute',
  STATIC = 'static',
}

export const webengageMappingSourceTypeOptions = Object.values(WebengageMappingSourceType).map((value) => ({
  label: CaseUtil.titleCase(value),
  value,
}));
